
import CustomButton from '../components/CustomButton/CustomButton';

const AboutUsSection = () => {
  return (
    <section className="py-3">
      <div className="container text-center">

        {/* Title */}
        <div className="row justify-content-center mb-4">
          <div className="col-12">
            <h2 className="text-black font-bold text-uppercase fs-4">
            GET IN TOUCH
            </h2>
          </div>
        </div>

        {/* Description */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-10 col-lg-8">
            <p className="fs-5">
            As Brand Acumen we specialize in innovative brand name developement. Our linguistic experts employ theoretical approaches to model brand language in a way that clarifies intuitions about core meanings and explains our creativity behind words without confusion.            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="row justify-content-center g-3">
          <div className="col-auto">
            <CustomButton
              label="CONTACT US"
              variant="red"
              size="small"
              href="/work-with-us"
              target=""
            />
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default AboutUsSection;
